module.exports = __webpack_public_path__ + "img/review.1081511e.png";